import type { LocalePack } from './types.js';

/** Dutch (Nederlands) */
export const nl: LocalePack = {
  headerTitle: 'Fotobewerker',
  headerSubtitle: 'Bewerk je afbeelding met gemak',
  applyButton: 'Toepassen',
  cancelButton: 'Sluiten',
  undo: 'Ongedaan maken',
  redo: 'Opnieuw',
  fullscreen: 'Volledig scherm',
  fit: 'Passend',
  zoomTooltip: 'Zoom · +/− · 0 passend · 1 100%',

  emptyStateTitle: 'Zet een afbeelding neer of klik om te uploaden',
  emptyStateSubtitle: 'Ondersteund: PNG, JPEG, HEIC',

  calloutLabelText: 'Label',

  tool: {
    select: 'Selecteren',
    crop: 'Bijsnijden',
    draw: 'Tekenen',
    eraser: 'Gum',
    text: 'Tekst',
    shapes: 'Vormen',
    callout: 'Notitie',
    filters: 'Filters',
    adjust: 'Aanpassen',
    move: 'Verplaatsen',
    pen: 'Pen',
    zoom: 'Zoom',
    zoomIn: 'Inzoomen',
    zoomOut: 'Uitzoomen',
    rotateLeft: 'Naar links draaien',
    rotateRight: 'Naar rechts draaien',
    flipH: 'H spiegelen',
    flipV: 'V spiegelen',
    reset: 'Herstellen',
  },

  shape: {
    circle: 'Cirkel',
    ellipse: 'Ellips',
    square: 'Vierkant',
    rectangle: 'Rechthoek',
    arrow: 'Pijl',
    polyline: 'Lijnpad',
  },

  filter: {
    none: 'Origineel',
    grayscale: 'Z/W',
    sepia: 'Sepia',
    vintage: 'Vintage',
    cool: 'Koel',
    warm: 'Warm',
    invert: 'Inverteren',
  },

  props: {
    title: {
      draw: 'Tekenen',
      eraser: 'Gum',
      text: 'Tekst',
      crop: 'Bijsnijden',
      shapes: 'Vormen',
      callout: 'Notitie',
      filters: 'Filters',
      adjust: 'Aanpassen',
      move: 'Verplaatsen',
    },
    aspectRatio: 'Beeldverhouding',
    applyCrop: 'Bijsnijden toepassen',
    cancel: 'Annuleren',
    shape: 'Vorm',
    preset: 'Voorinstelling',
    resetEffects: 'Effecten herstellen',
    resetAdjustments: 'Aanpassingen herstellen',
    deleteSelected: 'Selectie verwijderen',
    colors: 'Kleuren',
    recent: 'Recent',
    customColor: 'Aangepaste kleur',
    brushSize: 'Penseelgrootte',
    strokeWidth: 'Lijndikte',
    opacity: 'Dekking',
    eraserSize: 'Gumgrootte',
    fontSize: 'Tekengrootte',
    brightness: 'Helderheid',
    contrast: 'Contrast',
    saturation: 'Verzadiging',
    blur: 'Vervaging',
    quickActions: 'Snelle acties',
    hintMove:
      'Sleep om te pannen · knijp of scroll om te zoomen · kies een tool om te beginnen.',
    hintEraser: 'Tik of sleep over een annotatie om deze te verwijderen.',
  },
};
